import React, { useState } from 'react';
import SortIcon from './SortIcon';
import Pagination from './Pagination';
import { sortData } from './ksefHelpers';

const ReceiptToInvoice = ({
  receipts,
  totalReceipts,
  receiptsLimit,
  currentPage,
  filterDate,
  filterDateValue,
  setFilterDateValue,
  onFilterChange,
  onLimitChange,
  onPageChange,
  onCreateInvoice,
}) => {
  // Sorting
  const [sortColumn, setSortColumn] = useState('data_transakcji');
  const [sortDirection, setSortDirection] = useState('desc');

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const totalPages = Math.ceil(totalReceipts / receiptsLimit);
  const startIndex = (currentPage - 1) * receiptsLimit;
  const sortedReceipts = sortData(receipts, sortColumn, sortDirection);

  return (
    <div style={{
      backgroundColor: 'var(--card-bg)',
      borderRadius: '4px',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      overflow: 'hidden'
    }}>
      <div style={{
        border: '1px solid var(--primary)', color: 'var(--primary)' ,
        padding: '0.5rem 0.75rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '0.5rem'
      }}>
        <div>
          <span style={{ fontSize: '12px', fontWeight: '600' }}>🧾 Paragony do fakturowania</span>
          <small style={{ display: 'block', fontSize: '10px', opacity: 0.9 }}>
            Kliknij na paragon, aby utworzyc z niego fakture
          </small>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <label style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Filtr:</label>
          <select
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              border: '1px solid var(--border)',
              borderRadius: '6px',
              backgroundColor: 'var(--card-bg)',
              color: 'var(--text)'
            }}
            value={filterDate}
            onChange={(e) => onFilterChange(e.target.value)}
          >
            <option value="all">Wszystkie</option>
            <option value="today">Dzisiaj</option>
            <option value="month">Ten miesiac</option>
            <option value="custom">Wybierz date</option>
          </select>
          {filterDate === 'custom' && (
            <input
              type="date"
              style={{
                padding: '6px 10px',
                fontSize: '12px',
                border: '1px solid var(--border)',
                borderRadius: '6px',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--text)'
              }}
              value={filterDateValue}
              onChange={(e) => setFilterDateValue(e.target.value)}
            />
          )}
          <span style={{ fontSize: '10px', opacity: 0.9 }}>
            Strona {currentPage} z {totalPages || 1}
          </span>
        </div>
      </div>
      <div style={{ padding: '0.5rem' }}>
        {receipts.length === 0 ? (
          <p style={{ color: 'var(--text-secondary)', fontSize: '12px', textAlign: 'center', padding: '1rem' }}>Brak paragonow do wyswietlenia</p>
        ) : (
          <>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
                <thead>
                  <tr style={{ backgroundColor: 'var(--bg)' }}>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: '600', width: '40px', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('id')}>LP<SortIcon column="id" sortColumn={sortColumn} sortDirection={sortDirection} /></th>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: '600', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('numer_paragonu')}>Numer paragonu<SortIcon column="numer_paragonu" sortColumn={sortColumn} sortDirection={sortDirection} /></th>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: '600', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('data_transakcji')}>Data<SortIcon column="data_transakcji" sortColumn={sortColumn} sortDirection={sortDirection} /></th>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: '600', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('kasjer_login')}>Kasjer<SortIcon column="kasjer_login" sortColumn={sortColumn} sortDirection={sortDirection} /></th>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: '600', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('suma_brutto')}>Suma brutto<SortIcon column="suma_brutto" sortColumn={sortColumn} sortDirection={sortDirection} /></th>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: '600', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('ma_fakture')}>Czy ma fakture<SortIcon column="ma_fakture" sortColumn={sortColumn} sortDirection={sortDirection} /></th>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: '600' }}>Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedReceipts.map((receipt, idx) => (
                    <tr key={`receipt-${receipt.id}-${idx}`} style={{ backgroundColor: idx % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)' }}>
                      <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'center', color: 'var(--text-secondary)' }}>
                        {startIndex + idx + 1}
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)' }}>
                        <strong>{receipt.numer_paragonu || receipt.numer_transakcji}</strong>
                        <small style={{ display: 'block', color: 'var(--text-secondary)', fontSize: '10px' }}>
                          ID: {receipt.id}
                        </small>
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)' }}>
                        {receipt.data_transakcji}
                        <small style={{ display: 'block', color: 'var(--text-secondary)', fontSize: '10px' }}>
                          {receipt.czas_transakcji}
                        </small>
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)' }}>{receipt.kasjer_login}</td>
                      <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right', fontWeight: '600' }}>
                        {parseFloat(receipt.suma_do_zaplaty || receipt.suma_brutto).toFixed(2)} zl
                        {receipt.rabat_kwota > 0 && (
                          <small style={{ display: 'block', color: 'var(--danger)', fontSize: '9px' }}>
                            (rabat: -{parseFloat(receipt.rabat_kwota).toFixed(2)})
                          </small>
                        )}
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                        {receipt.ma_fakture ? (
                          <span style={{
                            padding: '0.15rem 0.4rem',
                            borderRadius: '3px',
                            fontSize: '9px',
                            backgroundColor: 'var(--success)',
                            color: 'white'
                          }}>
                            {'✅'} Tak ({receipt.numer_faktury})
                          </span>
                        ) : (
                          <span style={{
                            padding: '0.15rem 0.4rem',
                            borderRadius: '3px',
                            fontSize: '9px',
                            backgroundColor: 'var(--text-muted)',
                            color: 'white'
                          }}>
                            {'❌'} Nie
                          </span>
                        )}
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                        {!receipt.ma_fakture && (
                          <button
                            onClick={() => onCreateInvoice(receipt.id)}
                            style={{
                              padding: '4px 10px',
                              fontSize: '11px',
                              border: '1px solid var(--primary)',
                              color: 'var(--primary)'
                            }}
                          >
                            📧 Utworz fakture
                          </button>
                        )}
                        {receipt.ma_fakture && (
                          <button style={{
                            padding: '4px 10px',
                            fontSize: '11px',
                            backgroundColor: 'var(--border)',
                            color: 'var(--text-secondary)',
                            cursor: 'not-allowed'
                          }} disabled>
                            {'✅'} Ma fakture
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              startIndex={startIndex}
              perPage={receiptsLimit}
              totalItems={totalReceipts}
              onPageChange={onPageChange}
              onLimitChange={onLimitChange}
              label="paragonow"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ReceiptToInvoice;
